import {
  deriveCaseManagementWarning,
  deriveStatusNeedsReviewWarning,
  showCaseManagement,
} from '~support-at-home/lib/derive';
import { onChangeSahBudgets } from '~support-at-home/lib/onchange';
import { validateDateRange } from '~support-at-home/lib/validate';

import { Definition } from '~components/form-fields/Fields';

import { getAll as getAllClientBudgetStatuses } from '~support-at-home/actions/clientBudgetStatuses';

import { selectClientBudgetStatuses } from '~support-at-home/selectors/clientBudgetStatuses';

import SahBudgetSelect from '../../components/budgets/SahBudgetSelect';

const fields: Definition[] = [
  {
    key: 'status_id',
    type: 'select',
    caption: 'Status',
    selectorActions: getAllClientBudgetStatuses,
    selectorOptions: selectClientBudgetStatuses,
    disabled: (values: { needs_review?: boolean }) => !!values.needs_review,
    deriveWarning: deriveStatusNeedsReviewWarning,
    order: 100,
  },
  {
    key: 'start_date',
    type: 'date',
    caption: 'Start Date',
    validate: validateDateRange,
    order: 200,
  },
  {
    key: 'end_date',
    type: 'date',
    caption: 'End Date',
    validate: validateDateRange,
    order: 300,
  },
  {
    key: 'client_sah_budget_id',
    type: 'custom',
    caption: 'SAH Budget',
    component: SahBudgetSelect,
    dependencies: ['client_sah_budget_id', 'start_date', 'end_date', 'package_fixed_id'],
    onChange: onChangeSahBudgets,
    order: 400,
  },
  {
    key: 'total_amount',
    type: 'currency',
    caption: 'Total Amount',
    disabled: (values: any) => !!values.client_sah_budget_id,
    order: 500,
  },
  {
    key: 'total_includes_case_management',
    type: 'switch',
    caption: 'Includes Case Management',
    show: showCaseManagement,
    disabled: (values: any) => !!values.client_sah_budget_id,
    deriveWarning: deriveCaseManagementWarning,
    order: 600,
  },
];

export default fields;
